import { useNavigate } from 'react-router-dom'
import './style.css'

export function Button({ textBody, type = 'button', route = '/' }) {
  const navigate = useNavigate()

  const handleClick = () => {
    // Navigation logic can be added here in the future
    navigate(route)
  }

  return (
    <button className="button" onClick={handleClick} type={type}>
      {textBody}
    </button>
  )
}
